var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center loader-wrapper"},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"color":_vm.color,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }